import React, { useEffect, useState } from 'react';
import { AuthContext } from 'contexts';
import { AccessProvider } from 'contexts/access';
import { useNavigate, Outlet, useLocation, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { PortalProvider, usePortal } from 'contexts/portal';
import TeacherLayout from 'modules/teacher/TeacherLayout';
import CounselorLayout from 'modules/counselor/CounselorLayout';
import MobileShell from 'modules/admin/mobile/MobileShell';
import Layout from 'layout';
import ls from 'utils/ls';
import AiPanel from 'components/AiPanel';

// Утасны дэлгэц (< 768px) үү
const MOBILE_QUERY = '(max-width: 767px)';
const useIsMobile = () => {
  const [m, setM] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const on = (e) => setM(e.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => (mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on));
  }, []);
  return m;
};

// Ширээний зам → мобайл дүйцэх зам (утаснаас нээхэд)
const toMobilePath = (p) => {
  if (p.startsWith('/attendance/course')) return '/m/course';
  if (p.startsWith('/room-booking')) return '/m/booking';
  if (p.startsWith('/ai')) return '/m/ai';
  if (p.startsWith('/daycare')) return '/m/elementary';
  if (p.startsWith('/course/schedule')) return '/m/schedule';
  if (p.startsWith('/student/attendance')) return '/m/scan';
  return '/m';
};

// Горимоор layout сонгох: багш → TeacherLayout (утсанд ч мөн), зөвлөх → CounselorLayout, удирдлага → админ (утсанд /m).
// Давхар рольтой, сонгоогүй бол /choose.
const Shell = ({ isMobile, isMobileRoute }) => {
  const { mode, loading } = usePortal()
  const location = useLocation()
  const navigate = useNavigate()
  const path = location.pathname
  // Админ горим: утаснаас нээвэл мобайл руу ("ширээний горимыг хүчээр" сонгоогүй бол)
  useEffect(() => {
    if (mode === 'admin' && isMobile && !isMobileRoute && !ls.get('forceDesktop')) {
      navigate(toMobilePath(path), { replace: true })
    }
  }, [mode, isMobile, isMobileRoute, path])

  if (loading) return <div className="h-screen flex items-center justify-center"><Spin /></div>
  if (path === '/choose') return <Outlet />
  if (!mode) return <Navigate to="/choose" replace />
  if (mode === 'teacher') {
    if (path === '/' || path === '/m') return <Navigate to="/t" replace />
    if (isMobileRoute) return <MobileShell />
    return <TeacherLayout><Outlet /></TeacherLayout>
  }
  if (mode === 'counselor') {
    if (path === '/' || path === '/m') return <Navigate to="/c" replace />
    return <CounselorLayout><Outlet /></CounselorLayout>
  }
  if (isMobileRoute) return <MobileShell />
  return <Layout><Outlet /></Layout>
}

const RootPage = ({}) => {
  const authContext = React.useContext(AuthContext)
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useIsMobile()
  const isMobileRoute = location.pathname === '/m' || location.pathname.startsWith('/m/')

  useEffect(() => {
    if(!authContext.state.loading && !authContext.state.token) {
      navigate('/login')
    }
  }, [authContext.state.loading])

  if(authContext.state.loading) {
    return (
      <div>
        loading
      </div>
    )
  }
  if(authContext.state.token) {
    return (
      <AccessProvider key={authContext.state.token}>
        <PortalProvider>
          <Shell isMobile={isMobile} isMobileRoute={isMobileRoute} />
          {/* AI туслах — бүх горимд (админ, багш, зөвлөх) баруун талд */}
          <AiPanel />
        </PortalProvider>
      </AccessProvider>
    );
  }
  else {
    return (
      <Outlet>
      </Outlet>
    )
  }
}

export default RootPage;
